"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _DEPRECATED_CarouselModule = _interopRequireDefault(require("./DEPRECATED_Carousel.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var isTouchDevice = false;
if (typeof window !== 'undefined') {
  isTouchDevice = document && document.documentElement ? document.documentElement.ontouchstart !== undefined : false;
}
var variantConfig = {
  // Global configuration applied to all carousels but able to be overwritten
  global: {
    dotsClass: _DEPRECATED_CarouselModule.default['c-carousel__pagination']
    // customPaging defined in main Carousel component to allow thumbnails if defined
  },
  // Our basic product carousel showing 2 (mobile) to 4 items (desktop) items
  'multi-product': {
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    dots: true,
    responsive: [{
      breakpoint: 1023,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }]
  },
  // Peek products carousel showing peek products: 2.3 (mobile) to 5 items (desktop)
  'multi-product-peek': {
    slidesToShow: 5,
    slidesToScroll: 5,
    infinite: false,
    dots: false,
    arrows: true,
    responsive: [{
      breakpoint: 1023,
      settings: {
        slidesToShow: 4.45,
        // When we use decimal values for `slidesToShow` (peek product cards), react-slick shows a white space at the end of carousels depending on the number of products.
        // Adding this decimal value in `slidesToScroll` fixes this issue, avoiding a white space after the last product of the carousel.
        slidesToScroll: 4.001,
        arrows: !isTouchDevice,
        speed: 300
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 3.45,
        slidesToScroll: 3.001,
        arrows: !isTouchDevice,
        speed: 300
      }
    }, {
      breakpoint: 599,
      settings: {
        slidesToShow: 2.3,
        slidesToScroll: 2.001,
        arrows: !isTouchDevice,
        speed: 300
      }
    }]
  },
  'image-gallery': {
    lazyLoad: 'progressive',
    slidesToShow: 1,
    infinite: false,
    dots: true
  }
};
var _default = exports.default = variantConfig;